/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AdoptItemNodesInput,
  DestroySharedLibraryDiscardedItemNodesParams,
  ItemNode,
  ItemNodeCreateInput,
  ListSharedLibraryItemNodesParams,
  PaginatedItemNodes,
  PublishItemNodesError,
  PublishItemNodesInput,
  SchemaValidationErrorResponse,
  SearchSharedLibraryItemNodesParams,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Search Item Nodes across every readable Shared Library
 */
export const searchSharedLibraryItemNodes = (
    params?: MaybeRefOrGetter<SearchSharedLibraryItemNodesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedItemNodes>(
      {url: `/shared_libraries/item_nodes/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchSharedLibraryItemNodesQueryKey = (params?: MaybeRefOrGetter<SearchSharedLibraryItemNodesParams>,) => {
    return [
    'shared_libraries','item_nodes','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchSharedLibraryItemNodesQueryOptions = <TData = Awaited<ReturnType<typeof searchSharedLibraryItemNodes>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<SearchSharedLibraryItemNodesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSharedLibraryItemNodes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchSharedLibraryItemNodesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchSharedLibraryItemNodes>>> = ({ signal }) => searchSharedLibraryItemNodes(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchSharedLibraryItemNodes>>, TError, TData>
}

export type SearchSharedLibraryItemNodesQueryResult = NonNullable<Awaited<ReturnType<typeof searchSharedLibraryItemNodes>>>
export type SearchSharedLibraryItemNodesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Search Item Nodes across every readable Shared Library
 */

export function useSearchSharedLibraryItemNodes<TData = Awaited<ReturnType<typeof searchSharedLibraryItemNodes>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<SearchSharedLibraryItemNodesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSharedLibraryItemNodes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchSharedLibraryItemNodesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create an Item Node in a Shared Library
 */
export const createSharedLibraryItemNode = (
    companyId: MaybeRefOrGetter<number>,
    itemNodeCreateInput: MaybeRefOrGetter<ItemNodeCreateInput>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
itemNodeCreateInput = toValue(itemNodeCreateInput);

      return axiosClient<ItemNode>(
      {url: `/shared_libraries/${companyId}/item_nodes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: itemNodeCreateInput, signal
    },
      );
    }




export const getCreateSharedLibraryItemNodeMutationKey = () => ['createSharedLibraryItemNode'] as const;

export const getCreateSharedLibraryItemNodeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSharedLibraryItemNode>>, TError,CreateSharedLibraryItemNodeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSharedLibraryItemNode>>, TError,CreateSharedLibraryItemNodeMutationVariables, TContext> => {

const mutationKey = getCreateSharedLibraryItemNodeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSharedLibraryItemNode>>, CreateSharedLibraryItemNodeMutationVariables> = (props) => {
          const {companyId,data} = props ?? {};

          return  createSharedLibraryItemNode(companyId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSharedLibraryItemNodeMutationResult = NonNullable<Awaited<ReturnType<typeof createSharedLibraryItemNode>>>
    export type CreateSharedLibraryItemNodeMutationBody = ItemNodeCreateInput
    export type CreateSharedLibraryItemNodeMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateSharedLibraryItemNodeMutationVariables = {companyId: number;data: ItemNodeCreateInput}

    /**
 * @summary Create an Item Node in a Shared Library
 */
export const useCreateSharedLibraryItemNode = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSharedLibraryItemNode>>, TError,CreateSharedLibraryItemNodeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createSharedLibraryItemNode>>,
        TError,
        CreateSharedLibraryItemNodeMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSharedLibraryItemNodeMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Item Nodes in a Shared Library
 */
export const listSharedLibraryItemNodes = (
    companyId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListSharedLibraryItemNodesParams>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
params = toValue(params);

      return axiosClient<PaginatedItemNodes>(
      {url: `/shared_libraries/${companyId}/item_nodes`, method: 'GET',
        params, signal
    },
      );
    }




export const getListSharedLibraryItemNodesQueryKey = (companyId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListSharedLibraryItemNodesParams>,) => {
    return [
    'shared_libraries',companyId,'item_nodes', ...(params ? [params] : [])
    ] as const;
    }


export const getListSharedLibraryItemNodesQueryOptions = <TData = Awaited<ReturnType<typeof listSharedLibraryItemNodes>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(companyId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListSharedLibraryItemNodesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSharedLibraryItemNodes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListSharedLibraryItemNodesQueryKey(companyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSharedLibraryItemNodes>>> = ({ signal }) => listSharedLibraryItemNodes(companyId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(companyId) !== null && toValue(companyId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSharedLibraryItemNodes>>, TError, TData>
}

export type ListSharedLibraryItemNodesQueryResult = NonNullable<Awaited<ReturnType<typeof listSharedLibraryItemNodes>>>
export type ListSharedLibraryItemNodesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Item Nodes in a Shared Library
 */

export function useListSharedLibraryItemNodes<TData = Awaited<ReturnType<typeof listSharedLibraryItemNodes>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 companyId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<ListSharedLibraryItemNodesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSharedLibraryItemNodes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSharedLibraryItemNodesQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Adopt item nodes from a Shared Library
 */
export const adoptItemNodes = (
    companyId: MaybeRefOrGetter<number>,
    adoptItemNodesInput: MaybeRefOrGetter<AdoptItemNodesInput>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
adoptItemNodesInput = toValue(adoptItemNodesInput);

      return axiosClient<void>(
      {url: `/shared_libraries/${companyId}/item_nodes/adopt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adoptItemNodesInput, signal
    },
      );
    }




export const getAdoptItemNodesMutationKey = () => ['adoptItemNodes'] as const;

export const getAdoptItemNodesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adoptItemNodes>>, TError,AdoptItemNodesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adoptItemNodes>>, TError,AdoptItemNodesMutationVariables, TContext> => {

const mutationKey = getAdoptItemNodesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adoptItemNodes>>, AdoptItemNodesMutationVariables> = (props) => {
          const {companyId,data} = props ?? {};

          return  adoptItemNodes(companyId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdoptItemNodesMutationResult = NonNullable<Awaited<ReturnType<typeof adoptItemNodes>>>
    export type AdoptItemNodesMutationBody = AdoptItemNodesInput
    export type AdoptItemNodesMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type AdoptItemNodesMutationVariables = {companyId: number;data: AdoptItemNodesInput}

    /**
 * @summary Adopt item nodes from a Shared Library
 */
export const useAdoptItemNodes = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adoptItemNodes>>, TError,AdoptItemNodesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof adoptItemNodes>>,
        TError,
        AdoptItemNodesMutationVariables,
        TContext
      > => {
      return useMutation(getAdoptItemNodesMutationOptions(options), queryClient);
    }
    /**
 * @summary Empty the trash of a Shared Library
 */
export const destroySharedLibraryDiscardedItemNodes = (
    companyId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<DestroySharedLibraryDiscardedItemNodesParams>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
params = toValue(params);

      return axiosClient<void>(
      {url: `/shared_libraries/${companyId}/item_nodes/discarded`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDestroySharedLibraryDiscardedItemNodesMutationKey = () => ['destroySharedLibraryDiscardedItemNodes'] as const;

export const getDestroySharedLibraryDiscardedItemNodesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroySharedLibraryDiscardedItemNodes>>, TError,DestroySharedLibraryDiscardedItemNodesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroySharedLibraryDiscardedItemNodes>>, TError,DestroySharedLibraryDiscardedItemNodesMutationVariables, TContext> => {

const mutationKey = getDestroySharedLibraryDiscardedItemNodesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroySharedLibraryDiscardedItemNodes>>, DestroySharedLibraryDiscardedItemNodesMutationVariables> = (props) => {
          const {companyId,params} = props ?? {};

          return  destroySharedLibraryDiscardedItemNodes(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroySharedLibraryDiscardedItemNodesMutationResult = NonNullable<Awaited<ReturnType<typeof destroySharedLibraryDiscardedItemNodes>>>

    export type DestroySharedLibraryDiscardedItemNodesMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DestroySharedLibraryDiscardedItemNodesMutationVariables = {companyId: number;params?: DestroySharedLibraryDiscardedItemNodesParams}

    /**
 * @summary Empty the trash of a Shared Library
 */
export const useDestroySharedLibraryDiscardedItemNodes = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroySharedLibraryDiscardedItemNodes>>, TError,DestroySharedLibraryDiscardedItemNodesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroySharedLibraryDiscardedItemNodes>>,
        TError,
        DestroySharedLibraryDiscardedItemNodesMutationVariables,
        TContext
      > => {
      return useMutation(getDestroySharedLibraryDiscardedItemNodesMutationOptions(options), queryClient);
    }
    /**
 * @summary Publish item nodes into a Shared Library
 */
export const publishItemNodes = (
    companyId: MaybeRefOrGetter<number>,
    publishItemNodesInput: MaybeRefOrGetter<PublishItemNodesInput>,
 signal?: AbortSignal
) => {
      companyId = toValue(companyId);
publishItemNodesInput = toValue(publishItemNodesInput);

      return axiosClient<void>(
      {url: `/shared_libraries/${companyId}/item_nodes/publish`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: publishItemNodesInput, signal
    },
      );
    }




export const getPublishItemNodesMutationKey = () => ['publishItemNodes'] as const;

export const getPublishItemNodesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | PublishItemNodesError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishItemNodes>>, TError,PublishItemNodesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof publishItemNodes>>, TError,PublishItemNodesMutationVariables, TContext> => {

const mutationKey = getPublishItemNodesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishItemNodes>>, PublishItemNodesMutationVariables> = (props) => {
          const {companyId,data} = props ?? {};

          return  publishItemNodes(companyId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishItemNodesMutationResult = NonNullable<Awaited<ReturnType<typeof publishItemNodes>>>
    export type PublishItemNodesMutationBody = PublishItemNodesInput
    export type PublishItemNodesMutationError = ErrorType<SchemaValidationErrorResponse | void | PublishItemNodesError>
    export type PublishItemNodesMutationVariables = {companyId: number;data: PublishItemNodesInput}

    /**
 * @summary Publish item nodes into a Shared Library
 */
export const usePublishItemNodes = <TError = ErrorType<SchemaValidationErrorResponse | void | PublishItemNodesError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishItemNodes>>, TError,PublishItemNodesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof publishItemNodes>>,
        TError,
        PublishItemNodesMutationVariables,
        TContext
      > => {
      return useMutation(getPublishItemNodesMutationOptions(options), queryClient);
    }
